// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAHqd85vnEEHQTuMv7mV4K6q7jh70IEpx4",
  authDomain: "designer-b12ac.firebaseapp.com",
  projectId: "designer-b12ac",
  storageBucket: "designer-b12ac.appspot.com",
  messagingSenderId: "909128719219",
  appId: "1:909128719219:web:d85b26dff1b3a358920306"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;